module.exports = __webpack_public_path__ + "img/mainlogo_1280width-installerpadded.624a17f9.png";